import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
    static targets = ["item"]
    static classes = ["active"]

    connect() {
        document.addEventListener("trix-initialize", this.handleTrixInit)
        this.initSelect2()
    }

    disconnect() {
        document.removeEventListener("trix-initialize", this.handleTrixInit)
    }

    handleTrixInit(event) {
        const element = event.target
        if (element.dataset.readonly === "true") {
        element.editor.element.setAttribute("contenteditable", false)
        }
    }

    initSelect2() {
        if ($('#level_one_select').length === 0) return

        if ($('#level_one_select').hasClass('select2-hidden-accessible')) {
        $('#level_one_select').select2('destroy')
        }
        if ($('#level_two_select').hasClass('select2-hidden-accessible')) {
        $('#level_two_select').select2('destroy')
        }

        $('#level_one_select').select2({
            width: '100%',
            closeOnSelect: false,
            theme: 'bootstrap5',
            selectionCssClass: "form-control",
            containerCssClass: "form-control",
            dropdownCssClass: "custom-search-dropdown"
        })

        $('#level_two_select').select2({
            width: '100%',
            closeOnSelect: false,
            theme: 'bootstrap5',
            selectionCssClass: "form-control",
            containerCssClass: "form-control",
            dropdownCssClass: "custom-search-dropdown"
        })

        $('#level_one_select').on('select2:select', (e) => {
        let event = new Event('change', { bubbles: true })
        e.target.dispatchEvent(event)
        this.fetchLevelTwos()
        e.stopImmediatePropagation()
        })

        $('#level_one_select').on('select2:unselect', (e) => {
        let event = new Event('change', { bubbles: true })
        e.target.dispatchEvent(event)
        this.fetchLevelTwos()
        e.stopImmediatePropagation()
        })

        this.setMultiSelect()
    }

    setMultiSelect() {
        const levelOneIds = JSON.parse($('#level_one_ids').val() || '[]')
        const levelTwoIds = JSON.parse($('#level_two_ids').val() || '[]')

        if (levelOneIds.length === 0) return

        $('#level_one_select').val(levelOneIds).trigger('change')

        const query = levelOneIds.map(id => `level_one_ids[]=${id}`).join('&')
        fetch(`/level_twos_by_level_ones?${query}`)
        .then(res => res.json())
        .then(data => {
            const select = $('#level_two_select')
            select.empty()
            select.append(new Option('未選択', '', false, false))
            data.forEach(lt => {
            const isSelected = levelTwoIds.includes(lt.id)
            select.append(new Option(lt.name, lt.id, false, isSelected))
            })
            select.trigger('change')
        })
    }

    fetchLevelTwos() {
        const levelOneIds = $('#level_one_select').val() || []
        const currentLevelTwoIds = $('#level_two_select').val() || []

        if (levelOneIds.length === 0) {
        const select = $('#level_two_select')
        select.empty()
        select.append(new Option('未選択', '', false, false))
        select.trigger('change')
        return
        }

        const query = levelOneIds.map(id => `level_one_ids[]=${id}`).join('&')
        fetch(`/level_twos_by_level_ones?${query}`)
        .then(res => res.json())
        .then(data => {
            const select = $('#level_two_select')
            select.empty()
            select.append(new Option('未選択', '', false, false))
            data.forEach(lt => {
            const isSelected = currentLevelTwoIds.includes(String(lt.id))
            select.append(new Option(lt.name, lt.id, false, isSelected))
            })
            select.trigger('change')
        })
    }

    newBtnClick() {
        this.itemTargets.forEach(item => item.classList.remove(this.activeClass))
    }

    itemClick(event) {
        this.itemTargets.forEach(item => item.classList.remove(this.activeClass))
        
        const newsItem = event.currentTarget.closest("[data-news-target='item']") 
                        || event.currentTarget.closest(".news-item")
        if (newsItem) {
            newsItem.classList.add(this.activeClass)
        }
    }
}